<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      odooUrl: process.env.VUE_APP_Odoo_URL,
    }
  },
  created() {
    this.$store.commit("fetchOdooApi/getCountryState")
    this.$store.commit("fetchOdooApi/getCity")
    this.$store.commit("fetchOdooApi/getTownship")
  }
}
</script>
<style>
body {
  background-color: #f9f9f9;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f9f9f9;
  /* margin: 0 20px 60px 0; */
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
